var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveReturnsNavbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48745 0.703961C6.13477 0.351284 5.56297 0.351284 5.2103 0.703961L1.12195 4.79231C0.951638 4.95656 0.845703 5.18712 0.845703 5.44241C0.845703 5.53386 0.859295 5.62213 0.884568 5.70532C0.926252 5.84288 1.00147 5.97246 1.11021 6.0812C1.29152 6.26251 1.53075 6.35061 1.76834 6.3455H22.2492C22.748 6.3455 23.1523 5.94117 23.1523 5.44241C23.1523 4.94365 22.748 4.53933 22.2492 4.53933H6.7516L6.75158 1.36872C6.75849 1.12895 6.67045 0.886958 6.48745 0.703961Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2492 9.6543H1.74879C1.25003 9.6543 0.845703 10.0586 0.845703 10.5574C0.845703 11.0561 1.25003 11.4605 1.74879 11.4605H17.2489L17.2489 14.6039C17.2343 14.8525 17.3219 15.1061 17.5119 15.296C17.8645 15.6487 18.4363 15.6487 18.789 15.296L22.8891 11.196C23.2418 10.8433 23.2418 10.2715 22.8891 9.91881C22.7126 9.74232 22.4805 9.65415 22.2492 9.6543Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveReturnsNavbarIcon);
export default __webpack_public_path__ + "static/media/active-returns-navbar-icon.c109da081a9a31ea647c4943a015ee55.svg";
export { ForwardRef as ReactComponent };